export default "__VITE_ASSET__DgTxfWyn__"